import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DeletePopup from "../../components/DeletePopup";
import ReceiveDatePopup from "../ReceivedDatePopup";
import IViewProps from "./IView";
import * as adminActionCreators from "../AdminDashboard/actionCreators";
import * as draftListActionCreators from "../DraftRegistration/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import * as dynamicFormActions from "../DynamicForm/actionCreators";
import * as myCartActionCreators from "../MyCart/actionCreators";

import ReactGA from "react-ga";
import {
    dateTimeFormatter,
    getPersistData,
    getQueryString,
    setSessionValue,
    getSessionValue,
    handleRedirectAuth,
    setPersistData,
} from "../../utils/utils";

import {
    COPY_WARRANTY_DATA,
    CREATE_ANOTHER,
    WARRANTY_ERROR_CHECK,
    DRAFT_WARRANTY_SELECTED} from "../../constants/storageKeys";
import * as GAID from "../../../config.json";
import "../../../assets/sass/components/view.scss";
import AccessDenied from "../../widgets/AccessDenied";
import { PersistData } from "../../middleware/persistDataMiddleware";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

const Loading = (error: any) => {
    if (error) {
        return <div>Error on loading!</div>;
    } else {
        return <div>Loading...</div>;
    }
};

const DraftRegistration = Loadable({
    loader: () => import("../DraftRegistration"),
    loading: Loading,
});
const DynamicForm = Loadable({
    loader: () => import("../DynamicForm"),
    loading: Loading,
});

interface IViewStateProps {
    formID: any;
    forminstanceTypeId: any;
    isDeleteFlag: boolean;
    isRDPopupShown: boolean;
    receiveDatePopupVisible?: any;
    isCreateOrCopy: boolean;
}
/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
class View extends React.Component<IViewProps, IViewStateProps, {}> {
    constructor(props: IViewProps) {
        super(props);
        this.state = {
            formID: "Residential Warranty",
            forminstanceTypeId: 1,
            isDeleteFlag: false,
            isRDPopupShown: false,
            receiveDatePopupVisible: false,
            isCreateOrCopy: false,
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        const {
            isSubmittedForm,
            isAlreadyPaymentInitiated,
            globalActions,
            myCartActions,
            activeAction,
            layoutResponse: { JSONSchema, UISchema, ErrorSchema },
            layoutResponse,
        } = this.props;
        const { fetchDraftWarrentyList } = this.props.draftListActions;
        /* uncomment while implementing cdn changes */
        this.props.dynamicFormActions.GetContractorFormSettings();
        if (!activeAction) myCartActions.getActiveShoppingCart();
        if (Object.keys(layoutResponse).length === 0 || (!JSONSchema || !UISchema || !ErrorSchema)) {
            this.props.dynamicFormActions.fetchFormLayoutData({ payload: this.state.formID });
        }
        const persistData = getPersistData();
        if (persistData && isAlreadyPaymentInitiated) {
            if (persistData.warrantyId) this.tableRowSelection(persistData.warrantyId, persistData.forminstanceTypeId);
        } else if (!isSubmittedForm) {
            fetchDraftWarrentyList();
        } else if (isSubmittedForm) {
            globalActions.updateActiveScreen("NewForm");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            savedForms,
            deleteDraftID,
            draftListActions,
            globalActions,
            isSubmittedForm,
            userInfo,
            loading,
            activeScreen,
            activeAction,
            warrantyReceivedDate,
            isAlreadyPaymentInitiated,
            layoutResponse: { JSONSchema, UISchema },
        } = this.props;
        if (!!JSONSchema && !!UISchema) {
            if (getSessionValue(CREATE_ANOTHER)) {
                this.setState({
                    isCreateOrCopy: true,
                });
                const persistData: PersistData = getPersistData() || {};
                if (persistData.warrantyReceivedDate){
                    this.getReceivedDate(persistData.warrantyReceivedDate);
                }
                setSessionValue(CREATE_ANOTHER, "");
                setSessionValue(WARRANTY_ERROR_CHECK, "true");
                if (getSessionValue(COPY_WARRANTY_DATA)) {
                    setSessionValue(COPY_WARRANTY_DATA, "");
                    let persistData: PersistData = getPersistData() || {};
                    persistData = Object.assign(persistData, {
                        forceSaveWarranty: true,
                    });
                    setPersistData(persistData);
                    this.props.dynamicFormActions.fetchSavedFormDataAndCopy({});
                }
                globalActions.updateActiveScreen("NewForm");
            }
        }
        if (!this.state.isCreateOrCopy){
            if (userInfo && (userInfo.isAdmin || userInfo.isTm)) {
                if (isSubmittedForm || isAlreadyPaymentInitiated) {
                    globalActions.updateActiveScreen("NewForm");
                } else {
                    if (prevProps.savedForms.length !== savedForms.length) {
                        /* Redirects user to Dynamic Form screen on the initial load when no drafts available */

                        if (savedForms.length === 0 && prevProps.activeScreen !== "draftList") {
                            this.setState({ isDeleteFlag: false });
                            globalActions.updateActiveScreen("NewForm");
                        } else {
                            if (activeAction && activeAction === "editMode"){
                                globalActions.updateActiveScreen("NewForm");
                                this.props.myCartActions.updateActiveAction({ activeAction: null });
                            } else {
                                /* user remains on draft screen even after deleting the last draft */
                                globalActions.updateActiveScreen("draftList");
                                this.setState({ receiveDatePopupVisible: false, isRDPopupShown: false });
                            }
                        }
                    } else if (
                        !userInfo.isTm &&
                        !isSubmittedForm &&
                        prevProps.savedForms.length === 0 &&
                        savedForms.length === 0
                    ) {
                        if (activeAction && activeAction === "editMode") {
                            this.props.myCartActions.updateActiveAction({ activeAction: null });
                        } else {
                            if (activeScreen === "NewForm" && !warrantyReceivedDate)
                                globalActions.updateActiveScreen("draftList");
                            if (
                                // prevState.receiveDatePopupVisible !== this.state.receiveDatePopupVisible &&
                                !this.state.receiveDatePopupVisible &&
                                !this.state.isRDPopupShown &&
                                !loading
                            ) {
                                this.setState({ receiveDatePopupVisible: true, isRDPopupShown: true });
                            }
                        }
                    }
                    if (deleteDraftID && prevProps.deleteDraftID !== deleteDraftID) {
                        this.setState({ isDeleteFlag: true });
                        draftListActions.fetchDraftWarrentyList();
                    }
                }
            } else {
                if (prevProps.savedForms.length !== savedForms.length) {
                    /* Redirects user to Dynamic Form screen on the initial load when no drafts available */

                    if (savedForms.length === 0 && prevProps.activeScreen !== "draftList") {
                        this.setState({ isDeleteFlag: false });
                        globalActions.updateActiveScreen("NewForm");
                    } else {
                        if (activeAction && activeAction === "editMode"){
                            globalActions.updateActiveScreen("NewForm");
                            this.props.myCartActions.updateActiveAction({ activeAction: null });
                        } else {
                            /* user remains on draft screen even after deleting the last draft */
                            globalActions.updateActiveScreen("draftList");
                        }
                    }
                }
                if (deleteDraftID && prevProps.deleteDraftID !== deleteDraftID) {
                    this.setState({ isDeleteFlag: true });
                    draftListActions.fetchDraftWarrentyList();
                }
                // if((this.state.screenResolution.width !== window.innerWidth) && (this.state.screenResolution.height !== window.innerHeight)) {
                //     this.setState({ screenResolution: { width: window.innerWidth, height: window.innerHeight } }, ()=> {
                //         updateScreenResolution(this.state.screenResolution)
                //     })
                // }
            }
        }
    }

    tableRowSelection = (id, formInstanceId) => {
        const { updateActiveScreen } = this.props.globalActions;
        updateActiveScreen("NewForm");
        setSessionValue(DRAFT_WARRANTY_SELECTED, "true");
        setSessionValue(WARRANTY_ERROR_CHECK, "true");
        this.setState({ formID: id, forminstanceTypeId: formInstanceId });
    };

    createNewClick = () => {
        const {
            globalActions: { updateActiveScreen },
            userInfo,
        } = this.props;
        if (userInfo && userInfo.isAdmin) {
            this.setState({ receiveDatePopupVisible: true });
        } else {
            updateActiveScreen("NewForm");
            this.setState({ formID: "Residential Warranty", forminstanceTypeId: 1 });
            // const urlParams = new URLSearchParams(window.location.search);
            // const contractorId = urlParams.get("contractorId");
            const contractorId = getQueryString("contractorId", window.location.href);
            window["AppInsightTrace"].trackEvent("on create new button click");
            ReactGA.event({
                category: "Form Access",
                action: "Dashboard: Create New",
                label: `Dashboard: Create New: ${contractorId}: ${dateTimeFormatter(new Date())}`,
            });
        }
    };

    onDeletePopupConfirm = () => {
        const object = {
            ...this.props.deletePopupContent,
            title: "",
            description: "",
            buttonText: "",
            showPopup: false,
            confirm: true,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        document.body.classList.remove("hideOverflow");
    };

    onDeletePopupClose = () => {
        const object = {
            title: "",
            description: "",
            buttonText: "",
            showPopup: false,
            confirm: false,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        document.body.classList.remove("hideOverflow");
    };

    // callback function of resize eventListener
    handleResize() {
        this.props.globalActions.updateScreenResolution({ width: window.innerWidth, height: window.innerHeight });
    }

    hideReceiveDatePopup = () => {
        this.setState({ receiveDatePopupVisible: false });
    };

    getReceivedDate = (receivedDate) => {
        const {
            adminActions: { updateReceivedDate },
            globalActions: { updateActiveScreen },
        } = this.props;
        let persistData: PersistData = getPersistData() || {};
        persistData = Object.assign(persistData, {
            warrantyReceivedDate: receivedDate,
        });
        setPersistData(persistData);
        updateReceivedDate(receivedDate);
        //redirect to Create new screen
        updateActiveScreen("NewForm");
        // const urlParams = new URLSearchParams(window.location.search);
        // const contractorId = urlParams.get("contractorId");
        const contractorId = getQueryString("contractorId", window.location.href);
        window["AppInsightTrace"].trackEvent("on create new button click");
        ReactGA.event({
            category: "Form Access",
            action: "Dashboard: Create New",
            label: `Dashboard: Create New: ${contractorId}: ${dateTimeFormatter(new Date())}`,
        });
        this.setState({ formID: "Residential Warranty", forminstanceTypeId: 1, receiveDatePopupVisible: false });
    };

    initializeGA(pageview) {
        ReactGA.initialize(GAID["CONFIG"].googleAnalyticsID);
        //ReactGA.pageview(pageview);
    }
    render() {
        window.addEventListener("resize", this.handleResize);
        const {
            activeScreen,
            savedForms,
            deletePopupContent: { title, description, buttonText, tabIndex, showPopup },
            loading,
            userInfo,
            accessDeniedError,
        } = this.props;
        const { formID, forminstanceTypeId, isDeleteFlag, receiveDatePopupVisible } = this.state;
        let displayComponent;
        if (!loading && activeScreen === "draftList") {
            this.initializeGA("/DraftRegistration");
            displayComponent = (
                <DraftRegistration
                    isDeleteFlag={isDeleteFlag}
                    tableData={savedForms}
                    onCreateNew={this.createNewClick}
                    onTableRowSelection={this.tableRowSelection}
                />
            );
        } else if (!loading && activeScreen === "NewForm") {
            this.initializeGA("/DynamicForm");
            displayComponent = <DynamicForm formID={formID} forminstanceTypeId={forminstanceTypeId} />;
        }
        return (
            <div
                className={`main-content ${
                    userInfo && (userInfo.isAdmin || userInfo.isTm) ? "admin-main-content" : ""
                }`}
            >
                {userInfo && userInfo.isAdmin && receiveDatePopupVisible && (
                    <ReceiveDatePopup
                        title="Warranty received"
                        description="Date warranty was received"
                        buttonText="CONTINUE"
                        getReceivedDate={this.getReceivedDate}
                        hidePopUp={this.hideReceiveDatePopup}
                    />
                )}
                {showPopup && (
                    <DeletePopup
                        popupStatus={showPopup}
                        popupTitle={title}
                        popupDescription={description}
                        buttonText={buttonText}
                        onConfirm={() => this.onDeletePopupConfirm()}
                        onCancel={() => this.onDeletePopupClose()}
                        tabIndex={tabIndex}
                    />
                )}
                {displayComponent}
                {accessDeniedError && (
                    <AccessDenied
                        type={accessDeniedError ? "error" : ""}
                        message={accessDeniedError}
                        alertBoxClose={handleRedirectAuth}
                    />
                )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo,
        isSubmittedForm: state.adminData.isSubmittedForm,
        contractorInfo: state.adminData.contractorSelection,
        warrantyReceivedDate: state.adminData.warrantyReceivedDate,
        savedForms: state.draftListInfo.draftList,
        deleteDraftID: state.draftListInfo.deleteItem,
        deletePopupContent: state.draftListInfo.deletePopup,
        loading: state.globalInfo.loading,
        activeScreen: state.globalInfo.activeScreen,
        activeAction: state.myCartInfo.activeAction || null,
        screenResolution: state.globalInfo.screenResolution,
        accessDeniedError: state.globalInfo.accessDeniedError,
        isAlreadyPaymentInitiated: state.payments.isAlreadyPaymentInitiated,
        layoutResponse: state.dynamicFormInfo.layoutResponse,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        adminActions: bindActionCreators(adminActionCreators, dispatch),
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(View);
